module.exports = __webpack_public_path__ + "static/img/DigitalPayment.2b244984.jpg";